import { Col, Row } from "react-bootstrap";
import { STORAGE_URL } from "constants";
import { useLanguage } from "hooks";
import { Icons } from "components";
import { DEFAULT_USER_IMAGE } from "constants";

export default function AuthorCard({ item }) {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  
  return (
    <div className="position-relative">
      <Row className="author_card bg-light justify-content-center rounded-4 py-5 mx-0 px-0 px-lg-0 px-xl-2">
        <Col
          xs={12}
          className="d-flex justify-content-center align-items-center mb-3"
        >
          {/* show the author pic */}
          <img
            src={`${
              item.image && item.image !== ""
                ? STORAGE_URL + item.image
                : DEFAULT_USER_IMAGE
            }`}
            title={item.name}
            alt={item.name}
          />
        </Col>
        {/* show the author name (arabic and english) */}
        <Col xs={12} className="fw-bold text-blue mb-4 ">
          <h5 className="fw-bold text-blue text-center mb-0 cut-text-1 author_card_name">
            {item.name}
          </h5>
        </Col>
        <Col xs={12} className="px-2">
          <Row className="align-items-center g-1">
            <Col md={6} xs={6} className="">
              {/* show the author book number */}
              <Row className="h6 fw-medium mw-100 text-light4 align-items-center g-1">
                <Col md={3} xs={2} className="">
                  <Icons.Book
                    fill="#8F90A6"
                    width="22"
                    height="22"
                    small={"true"}
                    style={{ maxWidth: "100%" }}
                  />
                </Col>
                <Col md={9} xs={10} className="">
                  {item.books_count} {language.book}
                </Col>
              </Row>
            </Col>
            <Col md={6} xs={6} className="">
              {/* show the author views Number */}
              <Row className="h6 fw-medium mw-100 text-light4 align-items-center g-1">
                <Col md={3} xs={2} className="">
                  <Icons.Eye
                    width="22"
                    height="22"
                    style={{ maxWidth: "100%" }}
                  />
                </Col>
                <Col md={9} xs={10} className="">
                  {item.views_count} {language.views}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
